import React from "react";
import type { MerchantCouponListPageState } from "../../data/merchantCouponList.data";
import { CouponsRedeemedIcon } from "./icons/CouponsRedeemedIcon";
import { LowStockIcon } from "./icons/LowStockIcon";
import { TotalActiveCouponsIcon } from "./icons/TotalActiveCouponsIcon";
import { UsageCountIcon } from "./icons/UsageCountIcon";
import { SummaryCard } from "./SummaryCard";

interface MerchantCouponStatsProps {
  summary: MerchantCouponListPageState["summary"];
}

export const MerchantCouponStats: React.FC<MerchantCouponStatsProps> = ({ summary }) => (
  <div className="grid grid-cols-1 gap-3 w-full sm:grid-cols-2 sm:gap-4 lg:grid-cols-3 xl:grid-cols-4">
    <SummaryCard
      icon={<TotalActiveCouponsIcon className="h-[16.25px] w-[16.25px]" />}
      title="Total Active Coupons"
      value={summary.totalActiveCoupons}
    />
    <SummaryCard
      icon={<CouponsRedeemedIcon className="h-[16.25px] w-[16.25px]" />}
      title="Coupons Redeemed (in-app)"
      value={summary.couponsRedeemed}
    />
    <SummaryCard
      icon={<UsageCountIcon className="h-[16.25px] w-[16.25px]" />}
      title="Usage Count (in-store)"
      value={summary.usageCount}
    />
    <SummaryCard
      icon={<LowStockIcon className="h-[16.25px] w-[16.25px]" />}
      title="Low / Out of Stock"
      value={summary.lowOutOfStock}
    />
  </div>
);
